import { render } from "./toggle.vue?vue&type=template&id=048b7d97&scoped=true"
import script from "./toggle.vue?vue&type=script&lang=js"
export * from "./toggle.vue?vue&type=script&lang=js"

import "./toggle.vue?vue&type=style&index=0&id=048b7d97&scoped=true&lang=css"

import exportComponent from "/Users/tizetimoyosore/Developer/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048b7d97"]])

export default __exports__